import { chatbotStateActions } from '.';

export const { toggleOpen, toggleFullScreen, setSize, setHistory, saveConversation, setActiveHistoryId } = chatbotStateActions;
